export const CURRENCY_SYMBOLS = {
  AUD: '$',
  CAD: '$',
  CNY: '¥',
  EUR: '€',
  GBP: '£',
  HKD: '$',
  JPY: '¥',
  KRW: '₩',
  USD: '$'
};

export const CURRENCY_SYMBOLS_TEXT = {
  AUD: 'AUD $',
  CAD: 'CAD $',
  CNY: 'CNY ¥',
  EUR: 'EUR €',
  GBP: 'GBP £',
  HKD: 'HKD $',
  JPY: 'JPY ¥',
  KRW: 'KRW ₩',
  USD: 'USD $'
};

export const CURRENCY_OPTIONS = [
  { value: 'AUD', label: 'Australian Dollar (A$)' },
  { value: 'CAD', label: 'Canadian Dollar (CA$)' },
  { value: 'CNY', label: 'Chinese Yuan (¥)' },
  { value: 'EUR', label: 'Euro (€)' },
  { value: 'GBP', label: 'British Pound (£)' },
  { value: 'HKD', label: 'Hong Kong Dollar (HK$)' },
  { value: 'JPY', label: 'Japanese Yen (¥)' },
  { value: 'KRW', label: 'Korean Won (₩)' },
  { value: 'USD', label: 'US Dollar ($)' }
]; 